import { Box, Dialog } from "@mui/material";
import { SavedBrandContext } from "contexts/SavedBrand";
import { useContext } from "react";

import UploadBrands from ".";

const UploadBrandsMobile = () => {
  const { openUploadBrandsOnMobile, setOpenUploadBrandsOnMobile } =
    useContext(SavedBrandContext);

  return (
    <Dialog open={openUploadBrandsOnMobile} fullScreen>
      <Box sx={{ height: "100%", width: "100%", maxWidth: 480, mx: "auto" }}>
        <UploadBrands onClose={() => setOpenUploadBrandsOnMobile(false)} />
      </Box>
    </Dialog>
  );
};

export default UploadBrandsMobile;
